import React from "react";
import PropTypes from "prop-types";

export default function Tick(props) {
  return (
    <svg
      className={props.className}
      width={props.width}
      height={props.height}
      viewBox={`0 0 ${props.width} ${props.height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M84 168C130.392 168 168 130.392 168 84C168 37.6081 130.392 0 84 0C37.6081 0 0 37.6081 0 84C0 130.392 37.6081 168 84 168Z"
        fill="#F3F6FA"
      />
      <path
        d="M26.2389 77.0667L23 80.2667L67.2655 124L144.688 47.5L141.761 44L67.2655 117.6L26.2389 77.0667Z"
        fill="#063AC9"
      />
    </svg>
  );
}

Tick.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};
Tick.defaultProps = {
  className: "",
  width: 168,
  height: 168
};
